import classNames from 'classnames';
import { useRef } from 'react';
import LazyScrollBase from '../../components/LazyScrollBase/LazyScrollBase';
import ILazyScrollWindowProps from './LazyScrollWindowProps';

const LazyScrollWindow = <T extends object>({ offset = 1000, tag = 'div', sectionSize = 50, forwardRef, className, ...rest }: ILazyScrollWindowProps<T>) => {
  const lazyRef = useRef<HTMLElement>();

  function shouldLoadMore() {
    if (lazyRef.current) {
      return lazyRef.current.getBoundingClientRect().bottom - offset < window.innerHeight;
    } else {
      return false;
    }
  }

  function setRef(element: HTMLElement) {
    lazyRef.current = element;
    if (forwardRef) {
      forwardRef(element);
    }
  }

  return (
    <LazyScrollBase
      className={classNames('lazy-scroll-window', className)}
      trigger="self"
      forwardRef={setRef}
      tag={tag}
      sectionSize={sectionSize}
      shouldLoadMore={shouldLoadMore}
      {...rest}
    />
  );
};

export default LazyScrollWindow;
